function casablancaIstGeoeffnet() {
  const berlinZeit = new Intl.DateTimeFormat('de-DE', {
    timeZone: 'Europe/Berlin',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).formatToParts(new Date());

  const stunde = Number(
    berlinZeit.find((teil) => teil.type === 'hour').value
  );

  const minute = Number(
    berlinZeit.find((teil) => teil.type === 'minute').value
  );

  const minutenHeute = stunde * 60 + minute;

  // GEÖFFNET: 17:00 bis 01:59
  return minutenHeute >= 17 * 60 || minutenHeute < 2 * 60;
}

function casablancaBestellzeitenPruefen() {
  const offen = casablancaIstGeoeffnet();

  const kaufButtons = document.querySelectorAll(`
    button[name="add"],
    .add-to-cart-button,
    .quick-add__button,
    button[name="checkout"],
    a[href*="/checkout"],
    .shopify-payment-button
  `);

  kaufButtons.forEach((button) => {
    if (!offen) {
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.45';

      if ('disabled' in button) {
        button.disabled = true;
      }
    } else {
      button.style.pointerEvents = '';
      button.style.opacity = '';

      if ('disabled' in button) {
        button.disabled = false;
      }
    }
  });

  document.querySelectorAll('.casablanca-geschlossen').forEach((el) => {
    el.remove();
  });

  if (!offen) {
    const produktForm =
      document.querySelector('product-form') ||
      document.querySelector('form[action*="/cart/add"]');

    if (produktForm) {
      const meldung = document.createElement('div');
      meldung.className = 'casablanca-geschlossen';
      meldung.innerHTML = `
        🕒 <strong>Wir haben derzeit geschlossen.</strong><br>
        Bestellungen sind täglich von <strong>17:00 bis 02:00 Uhr</strong> möglich.
      `;

      meldung.style.cssText = `
        background:#111;
        color:#fff;
        border:1px solid #d4af37;
        border-radius:10px;
        padding:12px;
        margin:12px 0;
        text-align:center;
        font-size:14px;
        line-height:1.4;
      `;

      produktForm.parentElement.insertBefore(meldung, produktForm);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  casablancaBestellzeitenPruefen();

  const observer = new MutationObserver(() => {
    casablancaBestellzeitenPruefen();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/* Sicherheit: Checkout außerhalb der Öffnungszeiten blockieren */
document.addEventListener(
  'click',
  (event) => {
    if (casablancaIstGeoeffnet()) return;

    const ziel = event.target.closest(
      'button[name="add"], button[name="checkout"], a[href*="/checkout"], .shopify-payment-button, .add-to-cart-button'
    );

    if (!ziel) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    alert(
      'Wir haben derzeit geschlossen. Bestellungen sind täglich von 17:00 bis 02:00 Uhr möglich.'
    );
  },
  true
);